// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1qsfx","consentsList":"PatientConsents_consentsList__TUXjU","consentsListEmpty":"PatientConsents_consentsListEmpty__1G3Fl"};